export default __webpack_public_path__ + "assets/error-circle-component.79b85596.svg";